const resetPasswordTranslations = {
  en: {
    pageTitle: "Reset Password",
    heroTitle: "Reset Password",
    heroDesc: "Enter your new password",
    newPasswordPlaceholder: "New Password",
    confirmPasswordPlaceholder: "Confirm New Password",
    resetBtn: "Reset Password",
    resetting: "Resetting...",
    fillFields: "Please fill all fields.",
    minLength: "Password must be at least 6 characters.",
    mismatch: "Passwords do not match.",
    missingToken: "Invalid or missing reset token.",
    success: "Password reset successfully! You can now log in.",
    error: "Failed to reset password.",
  },
  pa: {
    pageTitle: "ਪਾਸਵਰਡ ਰੀਸੈਟ ਕਰੋ",
    heroTitle: "ਪਾਸਵਰਡ ਰੀਸੈਟ ਕਰੋ",
    heroDesc: "ਆਪਣਾ ਨਵਾਂ ਪਾਸਵਰਡ ਦਰਜ ਕਰੋ",
    newPasswordPlaceholder: "ਨਵਾਂ ਪਾਸਵਰਡ",
    confirmPasswordPlaceholder: "ਨਵਾਂ ਪਾਸਵਰਡ ਪੁਸ਼ਟੀ ਕਰੋ",
    resetBtn: "ਪਾਸਵਰਡ ਰੀਸੈਟ ਕਰੋ",
    resetting: "ਰੀਸੈਟ ਕੀਤਾ ਜਾ ਰਿਹਾ ਹੈ...",
    fillFields: "ਕਿਰਪਾ ਕਰਕੇ ਸਾਰੇ ਖੇਤਰ ਭਰੋ।",
    minLength: "ਪਾਸਵਰਡ ਘੱਟੋ-ਘੱਟ 6 ਅੱਖਰਾਂ ਦਾ ਹੋਣਾ ਚਾਹੀਦਾ ਹੈ।",
    mismatch: "ਪਾਸਵਰਡ ਮਿਲਦੇ ਨਹੀਂ ਹਨ।",
    missingToken: "ਰੀਸੈਟ ਟੋਕਨ ਗਲਤ ਜਾਂ ਗੁੰਮ ਹੈ।",
    success: "ਪਾਸਵਰਡ ਸਫਲਤਾਪੂਰਵਕ ਰੀਸੈਟ ਹੋ ਗਿਆ! ਹੁਣ ਤੁਸੀਂ ਲੌਗਇਨ ਕਰ ਸਕਦੇ ਹੋ।",
    error: "ਪਾਸਵਰਡ ਰੀਸੈਟ ਕਰਨ ਵਿੱਚ ਅਸਫਲ।",
  },
};

export default resetPasswordTranslations;
